import { blockRegistry } from "../registry/blocks";
import { defaultSettings } from "../schema/factory";

export const renderBlockHtml = (block, settings) => {
  const def = blockRegistry[block?.type];
  if (!def) return "";
  try {
    return def.toHtml(block.props || {}, settings);
  } catch (e) {
    console.error(`Failed to render block ${block?.type}:`, e);
    return "";
  }
};

export const renderHtml = (doc) => {
  const s = { ...defaultSettings, ...(doc?.settings || {}) };
  const blocks = doc?.blocks || [];

  const rows = blocks
    .map((b) => `<tr><td>${renderBlockHtml(b, s)}</td></tr>`)
    .join("\n");

  return `<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="color-scheme" content="light dark" />
<meta name="supported-color-schemes" content="light dark" />
<title></title>
<!--[if !mso]><!-->
<link rel="preconnect" href="https://fonts.googleapis.com" />
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet" />
<!--<![endif]-->
<style>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
  :root { color-scheme: light dark; supported-color-schemes: light dark; }
  body { margin:0; padding:0; width:100% !important; -webkit-text-size-adjust:100%; -ms-text-size-adjust:100%; }
  table { border-collapse:collapse; }
  img { -ms-interpolation-mode:bicubic; }
  @media only screen and (max-width:600px) {
    .email-container { width:100% !important; }
    .ecol { width:100% !important; max-width:100% !important; display:block !important; }
  }
  /* Keep the design identical in dark mode - we are already dark-aware,
     so explicitly lock our backgrounds against client auto-inversion. */
  @media (prefers-color-scheme: dark) {
    .email-bg { background-color:${s.backgroundColor} !important; }
    .email-card { background-color:${s.cardColor} !important; }
  }
  /* Outlook.com dark mode overrides */
  [data-ogsb] .email-bg { background-color:${s.backgroundColor} !important; }
  [data-ogsb] .email-card { background-color:${s.cardColor} !important; }
  /* Gmail dark-mode text-color preservation (Remi Parmentier blend hack).
     Scoped to Gmail only via the "u + .body" selector; ignored elsewhere.
     gmail-blend-screen/difference keep WHITE text white.
     gmail-blend-exclusion-blk/difference-blk keep DARK text dark. */
  u + .body .gmail-blend-screen { background:#000; mix-blend-mode:screen; }
  u + .body .gmail-blend-difference { background:#000; mix-blend-mode:difference; }
  u + .body .gmail-blend-exclusion-blk { background-color:#000; mix-blend-mode:exclusion; }
  u + .body .gmail-blend-difference-blk { background-color:#000; mix-blend-mode:difference; color:#fff; }
</style>
</head>
<body class="email-bg body" style="margin:0;padding:0;background-color:${s.backgroundColor};">
<table role="presentation" class="email-bg" width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="${s.backgroundColor}" style="background-color:${s.backgroundColor};">
  <tr>
    <td align="center" style="padding:24px 12px;">
      <table role="presentation" class="email-container email-card" width="${s.contentWidth}" cellpadding="0" cellspacing="0" border="0" bgcolor="${s.cardColor}" style="width:${s.contentWidth}px;max-width:${s.contentWidth}px;background-color:${s.cardColor};border-radius:8px;overflow:hidden;">
        ${rows}
      </table>
    </td>
  </tr>
</table>
</body>
</html>`;
};
